import { lazy } from 'react';

const CertifiedAvailableIntegrativePageConfig = {
	settings: {
		layout: {
			config: {
				footer: {
					display: false
				},
			}
		}

	},
	routes: [
		{
			path: '/certificates/integrative/avaibles',
			component: lazy(() => import('./CertifiedAvailablePage'))
		}
	]
};

export default CertifiedAvailableIntegrativePageConfig;